import { ACTION_TYPES } from '../constants';

export default page => ({
  type: ACTION_TYPES.FETCH_SUCCESS,
  payload: page
});
